<template>
  <div>
    {{ label.label }}
  </div>
</template>

<script>
export default {
mounted(){
    this.getlabel()
},
  data() {
    return {
      label: ""
    };
  },
  props: {
    item: {
      required: false,
    },
  },
  methods: {
    getlabel() {
      var self = this;
      var db = this.$firebase.firestore();

      var docRef = db.collection("typeDetailEtape").doc(self.item.type_champ);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
           
            self.label = doc.data()
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
  },
};
</script>

<style scoped></style>
